module.exports = __webpack_public_path__ + "static/media/au-plating.8664081f.png";